// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"196":"35e57ec6","245":"d9d8342f","443":"2f15e6f7","478":"d4570f50","547":"6dab9b00","630":"2cf83160","786":"3f57f7a5","935":"e44e32e6"}[chunkId] + ".css";
};